import benefits from '../../data/benefits.json';

import { createAddressObj } from '../../helpers/address';



export const cleanupStep4 = (data) => {

  if(data && data.benefits && data.benefits.isApproved) return data;
  
  const cleanedData = { ...data };
  
  // Функция для глубокой очистки benefits
  const resetBenefits = () => ({
    type: '',
    name: '',
    documentType: '',
    documentNumber: '',
    issuedTo: '',
    issueDate: '',
    files: [],
    address: createAddressObj(),
    kindergarten: '',
    siblingBirthCertificate: '',
    siblingName: '',
    siblingBirthDate: '',
    employeeName: '',
    employeeRnokpp: ''
  });

  // Если льгота не выбрана, полностью очищаем benefits
  if (!cleanedData.benefits.type || cleanedData.benefits.type === '') {
    cleanedData.benefits = resetBenefits();
    return cleanedData;
  }

  const selectedBenefit = benefits.find(b => b._id === cleanedData.benefits.type);
  
  if (!selectedBenefit) {
    cleanedData.benefits = resetBenefits();
    return cleanedData;
  }

  const benefitName = selectedBenefit.name.toLowerCase();

  // Детектор типа льготы
  const isTerritoryBenefit = benefitName.includes('територія обслуговування');
  const isSiblingBenefit = benefitName.includes('брати та сестри') || benefitName.includes('сестри в одному здо');
  const isEmployeeBenefit = benefitName.includes('працівників закладу') || benefitName.includes('працівників здо');
  const isRegularBenefit = !isTerritoryBenefit && !isSiblingBenefit && !isEmployeeBenefit;

  // Очистка в зависимости от типа льготы
  if (isTerritoryBenefit) {
    // Сохраняем только адрес
    const address = cleanedData.benefits.address || createAddressObj();
    const kindergarten = cleanedData.benefits.kindergarten || '';
    cleanedData.benefits = {
      ...resetBenefits(),
      type: cleanedData.benefits.type,
      kindergarten,
      name: cleanedData.benefits.name,
      address: address
    };

  } else if (isSiblingBenefit) {
    // Сохраняем только данные о ребенке и детском саде
    const kindergarten = cleanedData.benefits.kindergarten || '';
    const siblingBirthCertificate = cleanedData.benefits.siblingBirthCertificate || '';
    const siblingName = cleanedData.benefits.siblingName || '';
    const siblingBirthDate = cleanedData.benefits.siblingBirthDate || '';
    
    cleanedData.benefits = {
      ...resetBenefits(),
      type: cleanedData.benefits.type,
      name: cleanedData.benefits.name,
      kindergarten,
      siblingBirthCertificate: siblingBirthCertificate.toUpperCase().replace(/\s/g, ''),
      siblingName: siblingName.replace(/\s+/g, ' ').trim(),
      siblingBirthDate
    };

    // Дополнительная валидация для льготы братьев/сестер
    if (cleanedData.benefits.kindergarten && !cleanedData.benefits.siblingName) {
      // Если выбран сад, но нет имени ребенка - очищаем сад
      cleanedData.benefits.kindergarten = '';
    }

    if (cleanedData.benefits.siblingBirthDate) {
      const birthDate = new Date(cleanedData.benefits.siblingBirthDate);
      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 18); // Максимум 18 лет
      
      if (birthDate > new Date() || birthDate < minDate) {
        cleanedData.benefits.siblingBirthDate = '';
      }
    }

  } else if (isEmployeeBenefit) {
    // Сохраняем только данные работника и детского сада
    const kindergarten = cleanedData.benefits.kindergarten || '';
    const employeeName = cleanedData.benefits.employeeName || '';
    const employeeRnokpp = cleanedData.benefits.employeeRnokpp || '';
    
    cleanedData.benefits = {
      ...resetBenefits(),
      type: cleanedData.benefits.type,
      name: cleanedData.benefits.name,
      kindergarten,
      employeeName: employeeName.replace(/\s+/g, ' ').trim(),
      employeeRnokpp: employeeRnokpp.replace(/\D/g, '')
    };

    // Валидация РНОКПП работника
    if (cleanedData.benefits.employeeRnokpp && cleanedData.benefits.employeeRnokpp.length !== 10) {
      cleanedData.benefits.employeeRnokpp = '';
    }

    // Проверка согласованности данных
    if (cleanedData.benefits.kindergarten && !cleanedData.benefits.employeeName) {
      cleanedData.benefits.kindergarten = '';
    }

  } else {
    // Регулярные льготы с документами
    const documentType = cleanedData.benefits.documentType || '';
    const documentNumber = cleanedData.benefits.documentNumber || '';
    const issuedTo = cleanedData.benefits.issuedTo || '';
    const issueDate = cleanedData.benefits.issueDate || new Date().toISOString();
    const files = Array.isArray(cleanedData.benefits.files) ? cleanedData.benefits.files : [];
    
    cleanedData.benefits = {
      ...resetBenefits(),
      type: cleanedData.benefits.type,
      name: cleanedData.benefits.name,
      documentType: documentType.replace(/\s+/g, ' ').trim(),
      documentNumber: documentNumber.replace(/\s+/g, ' ').trim().toUpperCase(),
      issuedTo: issuedTo.replace(/\s+/g, ' ').trim(),
      issueDate,
      files
    };

    // Валидация даты выдачи
    if (cleanedData.benefits.issueDate) {
      const issueDateObj = new Date(cleanedData.benefits.issueDate);
      if (issueDateObj > new Date()) {
        cleanedData.benefits.issueDate = new Date().toISOString();
      }
    }

    // Проверка обязательных полей для документов
    if (cleanedData.benefits.documentNumber && !cleanedData.benefits.documentType) {
      cleanedData.benefits.documentNumber = '';
    }

    if (cleanedData.benefits.issuedTo && !cleanedData.benefits.documentNumber) {
      cleanedData.benefits.issuedTo = '';
    }
  }

  // Финальная проверка на согласованность данных
  const hasInconsistentData = () => {
    if (isTerritoryBenefit && cleanedData.benefits.address && !cleanedData.benefits.type) return true;
    if (isSiblingBenefit && cleanedData.benefits.siblingName && !cleanedData.benefits.kindergarten) return true;
    if (isEmployeeBenefit && cleanedData.benefits.employeeName && !cleanedData.benefits.kindergarten) return true;
    if (isRegularBenefit && cleanedData.benefits.documentNumber && !cleanedData.benefits.documentType) return true;
    return false;
  };

  if (hasInconsistentData()) {
    cleanedData.benefits = resetBenefits();
  }


  return cleanedData;
};